const helpTypes = {
  SPEECH_THERAPY: 'Fonoaudiología',
  PSYCHOMOTOR: 'Psicomotricista',
  PSYCHOPEDAGOGY: 'Psicopedagogía',
  PHYSIOTHERAPY: 'Fisioterapia',
  OTHER: 'Otro',
};

export default helpTypes;
